import '../assets/NcProgressBar-DDj4bmBB.css';
import { useCssVars as o } from "vue";
import { n as u } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const t = {
  name: "NcProgressBar",
  props: {
    /**
     * An integer between 1 and 100
     */
    value: {
      type: Number,
      default: 0,
      validator(e) {
        return e >= 0 && e <= 100;
      }
    },
    /**
     * Determines the height of the progressbar.
     * Possible values:
     * - 'small' (default)
     * - 'medium'
     * - Number
     * @type {'small'|'medium'|number}
     */
    size: {
      type: [String, Number],
      default: "small",
      validator(e) {
        return ["small", "medium"].includes(e) || typeof e == "number";
      }
    },
    /**
     * Applies an error color to the progressbar if true.
     */
    error: {
      type: Boolean,
      default: !1
    },
    /**
     * ProgressBar type
     */
    type: {
      type: String,
      default: "linear",
      validator(e) {
        return ["linear", "circular"].includes(e);
      }
    },
    color: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      stroke: 4
    };
  },
  computed: {
    height() {
      return this.type === "circular" ? Number.isInteger(this.size) ? this.size : 44 : this.size === "small" ? 4 : this.size === "medium" ? 6 : this.size;
    },
    progress() {
      return this.value / 100;
    },
    radius() {
      return this.height / 2;
    },
    radiusNormalized() {
      return this.radius - 3 * this.stroke;
    },
    circumference() {
      return this.radiusNormalized * 2 * Math.PI;
    }
  }
}, a = () => {
  o((e, r) => ({
    "0f3d9b00": e.color
  }));
}, i = t.setup;
t.setup = i ? (e, r) => (a(), i(e, r)) : a;
const c = t;
var n = function() {
  var r = this, s = r._self._c;
  return r.type === "circular" ? s("span", { staticClass: "progress-bar progress-bar--circular", class: { "progress-bar--error": r.error }, style: { "--progress-bar-height": r.height + "px" }, attrs: { role: "progressbar", "aria-valuenow": r.value } }, [s("svg", { attrs: { height: r.height, width: r.height } }, [s("circle", { attrs: { stroke: "currentColor", fill: "transparent", "stroke-dasharray": "".concat(r.progress * r.circumference, " ").concat((1 - r.progress) * r.circumference), "stroke-dashoffset": 0.25 * r.circumference, "stroke-width": r.stroke, r: r.radiusNormalized, cx: r.radius, cy: r.radius } }), s("circle", { attrs: { stroke: "var(--color-background-darker)", fill: "transparent", "stroke-dasharray": "".concat((1 - r.progress) * r.circumference, " ").concat(r.progress * r.circumference), "stroke-dashoffset": (0.25 - r.progress) * r.circumference, "stroke-width": r.stroke, r: r.radiusNormalized, cx: r.radius, cy: r.radius } })])]) : s("progress", { staticClass: "progress-bar progress-bar--linear vue", class: { "progress-bar--error": r.error }, style: { "--progress-bar-height": r.height + "px" }, attrs: { max: "100" }, domProps: { value: r.value } });
}, l = [], p = /* @__PURE__ */ u(
  c,
  n,
  l,
  !1,
  null,
  "bfe47e7c",
  null,
  null
);
const f = p.exports;
export {
  f as N
};
